import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Estilo para la barra de navegación

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="navbar">
      <div className="brand">Primera FEB Rosters</div>
      <button className="menu-button" onClick={toggleMenu}>
        ☰
      </button>
      <div className={`menu ${isOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <Link to="/teams">Equipos</Link>
          </li>
          <li>
            <Link to="/players">Jugadores</Link>
          </li>
          <li>
            <Link to="/coaches">Entrenadores</Link>
          </li>
          <li>
            <Link to="/countries">Países</Link>
          </li>
          <li>
            <Link to="/schedule">Pretemporada</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;